export default {
  namespaced: true,
  state: {
    active: false,
    activeObj: {},
  },
  getters: {
    active: state => state.active,
    activeObj: state => state.activeObj,
  },
  mutations: {
    activeMutate(state, data) {
      state.active = data;
    },
    activeObjMutate(state, data) {
      state.activeObj = data;
    },
  
  },
  actions: {

    setActive(context, data) {
      context.commit('activeMutate', data);
    },
    setActiveObj(context, data) {
      context.commit('activeObjMutate', data);
    },

  },
};
